/**
 * Single Case Study — Share widget in the sidebar.
 */

import { initShareWidget } from './share-widget';

document.querySelectorAll( '.single-case-study' ).forEach( initShareWidget );
